import { ListItemIcon, ListItemText } from '@/components/Dropdown/MenuItems/components';
import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import Arrange from '@/images/Arrange.svg';
import ArrowDown from '@/images/ArrowDown.svg';
import theme from '@/theme';
import styled from '@emotion/styled';
import MenuItem from '@mui/material/MenuItem';
import { StyledIconButton } from '../../StyledIconButton';

const RightArrow = styled(MaskedIcon)`
    transform: rotate(-90deg);
`;

const StyledListItemText = styled(ListItemText)`
    width: 100%;
`;

interface Props {
    inPopoverMenu?: boolean;
}

export const ArrangeItem = ({ inPopoverMenu }: Props) => {
    return (
        <>
            {inPopoverMenu ? (
                <MenuItem>
                    <ListItemIcon>
                        <MaskedIcon src={Arrange} color={theme.colors.secondary.main} size="16px" />
                    </ListItemIcon>
                    <StyledListItemText>Arrange</StyledListItemText>
                    <RightArrow src={ArrowDown} color={theme.colors.secondary.main} size="16px" />
                </MenuItem>
            ) : (
                <StyledIconButton ariaLabel="arrange" src={Arrange} />
            )}
        </>
    );
};
